"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var Spinner = /*#__PURE__*/function (_Component) {
  function Spinner(props) {
    var _this;
    _classCallCheck(this, Spinner);
    _this = _callSuper(this, Spinner, [props]);
    _this.animatedCircleRef = /*#__PURE__*/_react["default"].createRef();
    _this.drawCheck = _this.drawCheck.bind(_this);
    _this.reset = _this.reset.bind(_this);
    _this.startAnimation = _this.startAnimation.bind(_this);
    _this.stopAnimation = _this.stopAnimation.bind(_this);
    _this.finishAnimation = _this.finishAnimation.bind(_this);
    _this.finishedAnimationCallback = _this.finishedAnimationCallback.bind(_this);
    _this.add = _this.add.bind(_this);
    _this.setProgression = _this.setProgression.bind(_this);
    _this.validateOffset = _this.validateOffset.bind(_this);
    _this.inverseNormalOffset = _this.inverseNormalOffset.bind(_this);
    _this.state = {
      step: props.step === "" ? "animate" : props.step,
      spinnerMaxDashOffset: 2 * 3.14159265359 * props.radius,
      spinnerOffset: props.spinnerOffset ? _this.inverseNormalOffset(_this.validateOffset(props.spinnerOffset)) : 100,
      progressiveNumber: 0,
      currentProgressTime: 0,
      strokeWidth: props.strokeWidth,
      radius: props.radius,
      spinnerSpeed: props.spinnerSpeed,
      id: props.id ? props.id : "loader-".concat(Math.floor(Math.random() * 100000000)),
      drawCheck: false
    };
    if (props.isProgressive) {
      _this.startAnimation();
    }
    var keyframes = "@keyframes ".concat(_this.state.id, " {\n                0% {\n                  transform: rotateX(0deg);\n                  stroke-dashoffset: 0;\n                }\n            \n                25% {\n                  stroke-dashoffset: ").concat(_this.state.spinnerMaxDashOffset / 1.2, ";\n                }\n            \n                50% {\n                  transform: rotateX(0deg);\n                  stroke-dashoffset: ").concat(_this.state.spinnerMaxDashOffset, ";\n                }\n                50.01% {\n                  transform: rotateX(180deg);\n                  stroke-dashoffset: ").concat(_this.state.spinnerMaxDashOffset, ";\n                }\n            \n                75% {\n                  stroke-dashoffset: ").concat(_this.state.spinnerMaxDashOffset / 1.2, ";\n                }\n            \n                100% {\n                  transform: rotateX(180deg);\n                  stroke-dashoffset: 0;\n                }\n            }");
    var head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style');
    style.type = 'text/css';
    style.id = _this.state.id + "-style";
    if (style.styleSheet) {
      style.styleSheet.cssText = keyframes;
    } else {
      style.appendChild(document.createTextNode(keyframes));
    }
    head.appendChild(style);
    return _this;
  }
  _inherits(Spinner, _Component);
  return _createClass(Spinner, [{
    key: "inverseNormalOffset",
    value: function inverseNormalOffset(percent) {
      return (-100 + percent) * -1;
    }
  }, {
    key: "reset",
    value: function reset(animtype) {
      var self = this;
      var pfx = ["webkit", "moz", "MS", "o", ""];

      //animationend, animationstart, animationiteration
      var type = animtype || "animationiteration";
      for (var p = 0; p < pfx.length; p++) {
        if (!pfx[p]) type = type.toLowerCase();
        this.animatedCircleRef.current.removeEventListener(pfx[p] + type, self.finishedAnimationCallback, false);
      }
      var state = {
        step: "animate",
        drawCheck: false,
        spinnerOffset: 100,
        progressiveNumber: 0,
        currentProgressTime: 0
      };
      clearInterval(this.progressiveTimer);
      this.setState(state);
    }

    /*
    *
    *  default animation section
    *
     */
  }, {
    key: "deactivateAnimation",
    value: function deactivateAnimation() {
      this.setState({
        step: "inactive"
      });
    }
  }, {
    key: "drawCheck",
    value: function drawCheck() {
      this.setState({
        drawCheck: true
      });
    }
  }, {
    key: "finishAnimation",
    value: function finishAnimation(animtype) {
      var self = this;
      var pfx = ["webkit", "moz", "MS", "o", ""];

      //animationend, animationstart, animationiteration
      var type = animtype || "animationiteration";
      for (var p = 0; p < pfx.length; p++) {
        if (!pfx[p]) type = type.toLowerCase();
        this.animatedCircleRef.current.addEventListener(pfx[p] + type, self.finishedAnimationCallback, false);
      }
    }
  }, {
    key: "finishedAnimationCallback",
    value: function finishedAnimationCallback() {
      var self = this;
      this.setState({
        step: "done",
        drawCheck: true
      });
      setTimeout(function () {
        if (self.props.animationCompleteCallback) {
          self.props.animationCompleteCallback(self.state.id);
        }
      }, 800);
    }

    /*
    *
    *  Default + progressive
    *
     */
  }, {
    key: "startAnimation",
    value: function startAnimation() {
      var _this2 = this;
      var self = this;
      if (this.props.isProgressive) {
        // TODO : maybe later upgrade to actual time base animation with while loop (fps / frame rate based) for better animation

        this.progressiveTimer = setInterval(function () {
          var currentTime = _this2.state.currentProgressTime + _this2.props.progressiveDelay;
          if (currentTime > _this2.props.maxProgressiveTime || _this2.state.progressiveNumber > _this2.props.maxProgressiveNumber) {
            clearInterval(_this2.progressiveTimer);
          }
          var state = {
            spinnerOffset: _this2.inverseNormalOffset(currentTime * _this2.props.maxProgressivePercent / _this2.props.maxProgressiveTime),
            progressiveNumber: _this2.validateOffset(currentTime * _this2.props.maxProgressiveNumber / _this2.props.maxProgressiveTime, 0, _this2.props.maxProgressiveNumber),
            currentProgressTime: currentTime
          };
          _this2.setState(state);
        }, this.props.progressiveDelay);
      } else {
        this.setState({
          step: "animate"
        });
      }
    }
  }, {
    key: "stopAnimation",
    value: function stopAnimation() {
      var self = this;
      if (this.props.isProgressive) {
        clearInterval(this.progressiveTimer);
      } else {
        this.setState({
          step: "stop"
        });
      }
    }

    /*
    *
    *  Manual input section
    *
     */
  }, {
    key: "add",
    value: function add(percent) {
      var newNb = parseFloat(percent * -1) + this.state.spinnerOffset;
      this.setState({
        spinnerOffset: this.validateOffset(newNb)
      });
    }
  }, {
    key: "setProgression",
    value: function setProgression(percent) {
      var newNb = parseFloat(percent);
      this.setState({
        spinnerOffset: this.validateOffset(newNb)
      });
    }
  }, {
    key: "validateOffset",
    value: function validateOffset(nb) {
      var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      if (nb > max) {
        nb = max;
      } else if (nb < min) {
        nb = min;
      }
      return nb;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var el = document.getElementById(this.state.id + "-style");
      el.parentNode.removeChild(el);
      clearInterval(this.progressiveTimer);
    }
  }, {
    key: "render",
    value: function render() {
      var innerCircle = {
        strokeDasharray: this.state.spinnerMaxDashOffset,
        strokeWidth: this.state.strokeWidth,
        r: this.state.radius
      };
      var outerCircle = {
        strokeDashoffset: this.state.step === "done" ? 0 : this.state.spinnerMaxDashOffset,
        animationName: this.state.step === "done" || this.props.isManualInput || this.props.isProgressive ? "" : this.state.id,
        animationDuration: "".concat(this.state.spinnerSpeed, "s"),
        animationTimingFunction: 'linear',
        animationDelay: '0.0s',
        animationIterationCount: 'infinite',
        animationDirection: 'reverse',
        animationFillMode: 'both',
        strokeDasharray: this.state.spinnerMaxDashOffset,
        strokeWidth: this.state.strokeWidth + 1,
        r: this.state.radius
      };
      if (this.props.isManualInput || this.props.isProgressive) {
        var percent = this.validateOffset(this.state.spinnerOffset);
        outerCircle.strokeDashoffset = percent * this.state.spinnerMaxDashOffset / 100;
      }
      var spinnerContainerClass = (0, _classnames["default"])({
        "defaultSpinner": true,
        "inactive": this.state.step === "inactive",
        "animate": this.state.step === "animate" && !this.props.isManualInput && !this.props.isProgressive,
        "stopAnimation": this.state.step === "stop" || this.state.done,
        "done": this.state.step === "done",
        "progressive": this.props.isManualInput || this.props.isProgressive
      }, this.props.className);
      var checkClass = (0, _classnames["default"])({
        "checkmark": true,
        "draw": this.state.step === "done" || this.state.drawCheck
      });
      var checkCss = {
        strokeWidth: this.props.checkWidth
      };
      var progressiveText = this.props.progressiveText;
      if (progressiveText !== null && typeof progressiveText === "string") {
        if (this.props.isProgressive) {
          progressiveText = progressiveText.replace("${}", parseInt(this.state.progressiveNumber));
        } else if (this.props.isManualInput) {
          // by default the progress is already 100, so we need to inverse it
          progressiveText = progressiveText.replace("${}", parseInt(this.inverseNormalOffset(this.state.spinnerOffset)));
        }
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: spinnerContainerClass,
        id: this.state.id
      }, this.state.step !== "inactive" && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          position: "relative"
        }
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        className: "spinner",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        version: "1.1",
        preserveAspectRatio: "none",
        viewBox: "0 0 ".concat(this.state.radius * 2 + this.state.strokeWidth + 1, " ").concat(this.state.radius * 2 + this.state.strokeWidth + 1)
      }, /*#__PURE__*/_react["default"].createElement("circle", {
        className: "inner-circle",
        cx: "50%",
        cy: "50%",
        r: this.state.radius,
        style: innerCircle
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        ref: this.animatedCircleRef,
        className: "outer-circle",
        cx: "50%",
        cy: "50%",
        r: this.state.radius,
        style: outerCircle
      })), /*#__PURE__*/_react["default"].createElement("svg", {
        className: checkClass,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        fill: "none",
        d: "M14.1 27.2l7.1 7.2 16.7-16.8",
        style: checkCss
      })), progressiveText !== null && /*#__PURE__*/_react["default"].createElement("span", null, progressiveText)));
    }
  }]);
}(_react.Component);
Spinner.propTypes = {
  step: _propTypes["default"].oneOf(["animate", "stop", 'done', "inactive", ""]),
  strokeWidth: _propTypes["default"].number,
  radius: _propTypes["default"].number,
  spinnerSpeed: _propTypes["default"].number,
  checkWidth: _propTypes["default"].number,
  animationCompleteCallback: _propTypes["default"].func,
  isManualInput: _propTypes["default"].bool,
  isProgressive: _propTypes["default"].bool,
  progressiveText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object, _propTypes["default"].array]),
  maxProgressiveNumber: _propTypes["default"].number,
  maxProgressivePercent: _propTypes["default"].number,
  maxProgressiveTime: _propTypes["default"].number,
  spinnerOffset: _propTypes["default"].number,
  progressiveDelay: _propTypes["default"].number,
  id: _propTypes["default"].string
};
Spinner.defaultProps = {
  step: "",
  strokeWidth: 3,
  radius: 21,
  spinnerSpeed: 2,
  checkWidth: 1,
  animationCompleteCallback: function animationCompleteCallback() {},
  isManualInput: false,
  isProgressive: false,
  progressiveText: null,
  maxProgressiveNumber: 100,
  maxProgressivePercent: 100,
  maxProgressiveTime: 2000,
  progressiveDelay: 24,
  id: null
};
var _default = exports["default"] = Spinner;